// @flow
import React from 'react';

type LocationTerms = {
  city: ?string,
  region: ?string,
};

type Props = {
  locationTerms: LocationTerms,
  displaySeparator: ?boolean,
};

const propToItemProp = {
  address: 'streetAddress',
  city: 'addressLocality',
  region: 'addressRegion',
  cp: 'postalCode',
};

function formattedLocation(locationTerms) {
  return Object.entries(locationTerms)
    .sort()
    .filter(item => item[1])
    .map(([key, value], index, all) => (
      <span key={key}>
        <span itemProp={propToItemProp[key]}>{value}</span>
        {index + 1 < all.length && ', '}
      </span>
    ));
}

export default function Location({ locationTerms, displaySeparator }: Props) {
  const locationFormatted = formattedLocation(locationTerms);

  if (!locationFormatted) {
    return null;
  }

  return (
    <div
      className={`location${displaySeparator ? ' location--with-separator' : ''}`}
      itemProp="address"
      itemType="http://schema.org/PostalAddress"
    >
      {locationFormatted}
      <style jsx>
        {`
          .location {
            font-size: 14.4px;
            display: inline-block;
          }
          .location--with-separator:before {
            content: '·';
            margin: 0 0.2em;
          }
          :global(.rtl) .location :global(svg) {
            text-align: right;
          }
        `}
      </style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/common/Location/Location.jobs.js